var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-tabs',{model:{value:(_vm.activeName),callback:function ($$v) {_vm.activeName=$$v},expression:"activeName"}},[_c('el-tab-pane',{attrs:{"label":"人脸审核","name":"photoApprove"}},[_c('PhotoApprove')],1),_c('el-tab-pane',{attrs:{"label":"认证记录","name":"recognizeList"}},[_c('RecognizeList')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }